import { isEligibleLine } from '@/lib/withdrawal/eligibility';
import type {
  WithdrawalEligibility,
  WithdrawalEligibilityLine,
} from '@/lib/withdrawal/types';

export type OrderLineWithdrawalCaptionModel =
  | { variant: 'hidden' }
  | { variant: 'eligible' }
  | {
      eligibilityLine: WithdrawalEligibilityLine | null;
      variant: 'ineligible';
    };

export function getOrderLineWithdrawalCaptionModel(
  orderLineId: string,
  eligibility: WithdrawalEligibility | null,
  isWithdrawalEligibilityLoading: boolean,
): OrderLineWithdrawalCaptionModel {
  if (isWithdrawalEligibilityLoading) {
    return { variant: 'hidden' };
  }
  if (eligibility?.code !== 'OK') {
    return { variant: 'hidden' };
  }

  const eligibilityLine =
    eligibility.lines.find((l) => l.orderLineId === orderLineId) ?? null;
  const isKnown = Boolean(eligibilityLine);
  const isEligible = eligibilityLine ? isEligibleLine(eligibilityLine) : false;

  if (eligibilityLine?.disabledReasonCode === 'OUT_OF_EU_SCOPE') {
    return { variant: 'hidden' };
  }

  if (isKnown && isEligible) {
    return { variant: 'eligible' };
  }

  return { eligibilityLine, variant: 'ineligible' };
}
